<template>
  <div class="main-container history-page-active ma-2">
    <div class="flex s-bt">
      <div>
        <v-btn style="border:none; box-shadow: none; width:8px;"  class="mt-1" href="/monitoring/summary">
          <v-img src="@/assets/monitoring.svg" class="pa-1 ml-2"/>
        </v-btn>

        <v-btn style="border:none; box-shadow: none; width:8px;"  class="mt-1" href="/listDataSendLog">
          <v-icon size="36" color="#4A5568" >mdi-file-document</v-icon>
        </v-btn>
      </div>
      
      <div class="text-end" style="line-height:20px;">
        <!-- <div class="time-info">현재시간</div> -->
        <div class="bold-weight info-value flex">
          <div>
          <div class="small-text gray-color" style="font-weight:500;">조회시각</div>
          <span>{{ to_date }}</span>

          </div>
          <v-btn class="normal-btn" @click="refresh">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </div>

     
      </div>

      <!-- <div>
        <v-btn class="normal-btn" @click="refresh">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </div> -->
    </div>

    <div class="first-section flex mt-3">
      <div class="install-farm info-centents" style="cursor:default;">
        <div class="bold-weight mb-4">전체 설치 사업장</div>

        <div class="flex">
          <div class="chart_layout">
            <Doughnut
              style="width:100% !important; height:100% !important;"
              id="tempChart"
              ref="tempChart"
              :chart-options="chartOptions"
              :chart-data="chartFarmData"
            />
            <div class="center-text">
              <div class="center-number">{{ totalFarmCount }}</div>
              <div class="center-label">개소</div>
            </div>
          </div>
        </div>
      </div>

      <div class="as-info info-centents" @click="$router.push('/as-admin')">
        <div class="bold-weight">A/S 처리 현황</div>

        <div v-if="asloading" class="loading-container" >
          <div class="spinner"></div>
        </div>
        <div class="mt-7 flex s-bt as-detail" v-if="!asloading">
          <div class="as-check no-check mr-5">
            <div class="bold-weight orange-color ml-text">
              <v-icon size="32" color="#FA7E27">
                mdi-rotate-45
                mdi-paperclip
              </v-icon>
              <span class="as-title">미확인</span>
            </div>
            <div>
              <span class="xl-text bold-weight">{{ AsStatus.new }} </span>
              <span class="semi-bold ml-text ml-1 ">건</span>
            </div>
          </div>
          <div class="as-check ing-check mr-5">
            <div class="bold-weight blue-color ml-text">
              <v-icon size="32" color="#3C82F6">
                mdi-account-check
              </v-icon>
              <span class="as-title">진행중</span>
            </div>
            <div>
              <span class="xl-text bold-weight">{{ AsStatus.ing }}</span>
              <span class="semi-bold ml-text ml-2">건</span>
            </div>
          </div>
          <div class="as-check comp-check">
            <div class="bold-weight green-color ml-text">
              <v-icon size="32" color="#22C55D">
                mdi-checkbox-marked-circle-outline
              </v-icon>
              <span class="as-title">완료</span>
            </div>
            <div>
              <span class="xl-text bold-weight">{{ AsStatus.end }}</span>
              <span class="semi-bold ml-text ml-2">건</span>
            </div>
          </div>

        </div>
      </div>

      <div class="as-info info-centents"  @click="$router.push('/smsdetail')">
        <div class="bold-weight">문자 발송 현황</div>

        <div v-if="smsloading" class="loading-container" >
          <div class="spinner"></div>
        </div>

        <div class="mt-3" v-if="!smsloading">
          <div class="sms-title">
            <!-- <v-icon size="16" class="mr-1 pointer">mdi-information-outline</v-icon> -->
            <div>
              <div class="flex " style="justify-content: space-between;">
                <div>
                  <span class="bold-weight darkgray-color">이용 중인 사업장 </span>
                  <!-- <span class="bold-weight lightblue-color"> {{ smsStatus.seted.cnt}} 개소</span> -->
                </div>

                <div class="info-wrapper">
                  <span class="bold-weight lightblue-color mr-1"> {{ smsStatus.seted.cnt}} 개소</span>
                  <v-icon size="16" class="craw-info mb-1">mdi-information-outline</v-icon>

                <div class="omission-info">
                  <div><strong>• 서비스 이용 농가</strong></div>
                  <!-- {{ smsStatus }} -->
                  <div v-for="(farm, f) in smsStatus.seted.farms" :key="f" class="flex">
                  - {{ farm }}
                  </div>
                </div>
              </div>
            </div>

            <div class="flex" style="justify-content: space-between;">
              <div class="bold-weight darkgray-color" style="font-size:0.8rem">
                잔여요금
              </div>

              <div class="bold-weight lightblue-color mr-1" style="font-size:0.8rem">
                {{ smsStatus.remain.won }} 원
              </div>
            </div>
            


          </div>
          </div>

          <div class="mt-3">
            <div class="flex" style="justify-content: space-around;" >
              <div>
                <v-icon>mdi-clock-outline</v-icon>
                <span class="ml-1">당일 발송</span>
              </div>

              <div>
                <span class="bold-weight ml-text">{{ smsStatus.today.farm }}개소</span>
                <span class="ml-1">({{ smsStatus.today.sms }} 건)</span>
              </div>
            </div>

            <div class="line mt-1 mb-1" style="width:80%; margin:0 auto;"></div>

            <div class="flex" style="justify-content: space-around;" >
              <div>
                <v-icon>mdi-chart-line-variant</v-icon>
                <span class="ml-1">주간 발송</span>
              </div>

              <div>
                <span class="bold-weight ml-text">{{ smsStatus.week.farm }}개소</span>
                <span class="ml-1">({{ smsStatus.week.sms }} 건)</span>
              </div>
            </div>

            <div class="line mt-1 mb-1" style="width:80%; margin:0 auto;"></div>
            
            <div class="flex" style="justify-content: space-around;" >
              <div>
                <v-icon>mdi-calendar-blank</v-icon>
                <span class="ml-1">월간 발송</span>
              </div>

              <div>
                <span class="bold-weight ml-text">{{ smsStatus.month.farm }}개소</span>
                <span class="ml-1">({{ smsStatus.month.sms }} 건)</span>
              </div>
            </div>



            <div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="second-section flex mt-3">
      <div class="mgate-info info-centents" @click="$router.push('/connect/multiGate')">
        <div class="flex s-bt">
          <div class="bold-weight">멀티게이트 통신 상태</div>
          <v-icon class="contents-btn" @click.stop="monitorGateway()">mdi-refresh</v-icon>
        </div>
       

        <div v-if="gwloading" class="connect-loading mb-3 mt-2" >
          <div class="thin-spinner "></div>
        </div>

        <div class="mt-3" v-if="!gwloading" >
          <span class="percent-info bold-weight">{{ gwRatio }} </span>
          <span class="unit">%</span>
        </div>

        <div class="small-text">
          <span> 멀티게이트 통신 정상률 </span>
        </div>

        <div class="flex mt-2">
          <div class="multigate-content">
           
            <div class="flex align-center s-bt">
              <div class="bold-weight">정상통신</div>
              <div class="ml-text bold-weight">{{ gwStatus.connected }} </div>
            </div>
          
          </div>

          <div class="multigate-content ml-2">
           
           <div class="flex align-center s-bt">
             <div class="bold-weight flex">
                <span>비정상통신</span>
                <div class="info-wrapper">
                <v-icon size="18" color="#F3AA9B" class="craw-info ml-1 mb-1">mdi-alert-outline</v-icon>

                <div class="omission-info" style="font-size:0.9rem;">
                  <div>🔴 통신불량 : {{ gwStatus.unconnected }} 개</div>
                  <div>🔴 등록불량 : {{ gwStatus.unknown }} 개</div>
                </div>
              </div>
              </div>
             <div class="ml-text bold-weight">{{ gwStatus.unconnected + gwStatus.unknown }} </div>
           </div>

         </div>

        </div>

        <div class="line mt-2 mb-2"></div>

        <div class="flex s-bt pa-1">
          <div class="bold-weight">총 멀티게이트 수</div>
          <div class="gray-color bold-weight ml-text"> {{ gwStatus.total }} </div>
        </div>

       
      </div>

      <div class="as-info info-centents" @click="$router.push('/connect/controller')">
        <div class="flex s-bt">
          <div class="bold-weight">컨트롤러 통신 상태</div>
          <v-icon class="contents-btn" @click.stop="monitorControl()">mdi-refresh</v-icon>
        </div>

        <div v-if="fcloading" class="connect-loading mb-3 mt-2" >
          <div class="thin-spinner "></div>
        </div>

        <div class="mt-3" v-if="!fcloading" >
          <span class="percent-info bold-weight">{{ fcRatol }} </span>
          <span class="unit">%</span>
        </div>

        <div class="small-text">컨트롤러 통신 정상률</div>

        <div v-if="fcloading" class="connect-loading ml-1" >
          <div class="thin-spinner "></div>
        </div>

        <div class="flex mt-2">
          <div class="fc-contents mr-1" v-for="(fc, f) in controlStatus" :key="f">
            <div class="flex s-bt">
              <div class="bold-weight small-text">{{ fc.type}}</div>
              <div class="ratio-info small-text">{{ fcRatio(fc) }} %</div>
            </div>

            <div v-if="fcloading" class="connect-loading ml-1" >
              <div class="thin-spinner "></div>
            </div>

            <div class="flex" >
              <div class="ml-text bold-weight" v-if="!fcloading">
                <span>{{ fc.normal }}</span>
                <span class="gray-color">/ {{ fc.total }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="line mt-2 mb-2"></div>

        <div class="flex s-bt pa-1">
          <div class="bold-weight">총 문제 건수</div>
          <div class="red-color bold-weight ml-text"> {{ fcTotalError }} </div>
        </div>


      </div>

      <div class="sensor-info info-centents">
        <div class="flex s-bt">
          <div class="bold-weight">센서 모니터링</div>
          <v-icon class="contents-btn" @click.stop="sensorNode()">mdi-refresh</v-icon>
        </div>

        <div v-if="nodeloading" class="connect-loading mb-3 mt-2" >
          <div class="thin-spinner "></div>
        </div>

        <div class="mt-3" v-if="!nodeloading" >
          <span class="percent-info bold-weight">{{ nodeRatio }} </span>
          <span class="unit">%</span>
        </div>

        <div class="small-text">
          <span> 센서노드 수신 정상률 </span>
        </div>

        <div class="flex mt-2">
          <div class="flex sensor-hover" style="width:70%;" @click="$router.push('/connect/sensorNode')">
            <div class="sensornode-content" style="width:50%;">
           
            <div class="flex align-center s-bt">
              <div class="bold-weight">정상수신</div>
              <div class="ml-text bold-weight">{{ nodeStatus.connected }} </div>
            </div>
          
          </div>

          <div class="sensornode-content ml-1" style="width:50%;">
            
            <div class="flex align-center s-bt">
              <div class="bold-weight flex">
                <span >수신불량</span>
                <div class="info-wrapper">
                  <v-icon size="18" color="#F3AA9B" class="craw-info ml-1 mb-1">mdi-alert-outline</v-icon>

                <div class="omission-info" style="font-size:0.9rem;">
                  <div>🔴 수신불량 : {{ nodeStatus.unconnected }} 개</div>
                  <div>🔴 등록불량 : {{ nodeStatus.unknown }} 개</div>

                </div>
              </div>
              </div>
              <div class="ml-text bold-weight">{{ nodeStatus.unconnected + nodeStatus.unknown }}</div>
            </div>
          </div>
          </div>

          <div class=" ml-1 sensornode-content sensor-hover" @click="abnormalSensor()">
           <div class="flex align-center s-bt" >
             <div class="bold-weight">비정상 센서</div>
             <div class="ml-text bold-weight">{{ nodeStatus.abnormal }} </div>
           </div>
         </div>
        </div>

        <div class="line mt-2 mb-2"></div>

        <div class="flex s-bt pa-1">
          <div class="bold-weight">총 센서노드 수</div>
          <div class="gray-color bold-weight ml-text"> {{ nodeStatus.total }} </div>
        </div>

        <!--출하 크롤링-->
        <v-dialog
          v-model="sensorDialog"
          width="450"
        >
          <v-card
            max-width="450"
          >
          <div  class="dialog-title flex s-bt"> 
            <div>
              <v-icon color="white" class="mr-1">mdi-cloud-off-outline</v-icon>
              비정상 센서 상세
            </div>
            <div @click="sensorDialog = false;" style="cursor: pointer;">
              <v-icon color="white">mdi-close</v-icon>
            </div>
          </div>
        
          <div class="pa-5" >
            <div class="upload-detail mb-2" v-for="(info, i ) in abnormal_Sensor" :key="i" style="cursor: pointer;" @click="roterBarometer(info)">
              <div class="upload-detail-title bold-weight flex s-bt align-center" style="background-color: white; border-bottom: 1px solid #E5E7EB;">
                <div>
                  {{ info.farm }} {{ info.room }} 
                </div>
                <div class="small-text">
                  <div style="font-size:0.7rem; margin-bottom:-5px;" class="gray-color">마지막 수신</div>
                  <span class="small-text gray-color">{{ info.check.date}}</span>
                </div>
                
              </div>

              <div class="shipupload-container sensor ml-1 ">
                <div class="small-text abnormal-sensor-container ">
                  <div><v-icon size="12" class="mr-1" color="#a6ffc5">mdi-checkbox-blank-circle</v-icon>
                    실시간 수신 값
                  </div>
                  <div class="small-text normal-sensor" style="font-size:0.9rem !important;">
                   <div v-if="'temp' in info.check.values ">🌡️ 온도 ({{ info.check.values.temp }})</div>
                   <div v-if="'hum' in info.check.values ">💧 습도 ({{ info.check.values.hum }})</div>
                   <div v-if="'co2' in info.check.values ">☁️ co2 ({{ info.check.values.co2 }})</div>
                   <div v-if="'nh3' in info.check.values ">💨 nh3 ({{ info.check.values.nh3 }})</div>
                   <div v-if="'h2s' in info.check.values ">🧪 h2s ({{ info.check.values.h2s }})</div>
                   <div v-if="'bp' in info.check.values ">🌫️ 기압 ({{ info.check.values.bp }})</div>
                   <div v-if="'wd' in info.check.values ">🍃 풍향 ({{ info.check.values.wd }})</div>
                   <div v-if="'ws' in info.check.values ">🌬️ 풍속 ({{ info.check.values.ws }})</div>

                  </div>
                </div>
            

                <div class="mt-1 abnormal-sensor-container abnormal-sensor-list">
                  <div class="small-text">
                    <v-icon size="12" class="mr-1" color="#ff974d">mdi-minus-circle</v-icon>
                    비정상 센서
                  </div>
                  <div class="abnormal-sensor">
                    <div v-for="(value, v) in info.check.abnormal" :key="v" class="mr-3 sensor-chip mt-1">
                      <div> <v-icon color="white" size="12" class="">mdi-alert</v-icon>{{ value }} </div> 
                    </div>
                  </div>
                </div>
                
              
              </div>

            
            </div>
            </div>
          </v-card>
        </v-dialog>
      </div>
    </div>

    <div class="third-section flex mt-3">
      <div class="data-info info-centents">
        <div class="bold-weight flex">
          <span>데이터 크롤링 현황</span>
          <div class="info-wrapper">
            <v-icon size="16" class="craw-info">mdi-information-outline</v-icon>

            <div class="omission-info">
              <div><strong>• 크롤링 누락 기준</strong></div>
              <div>- 출하 : 데이터가 아예 없거나 7일 이내 출하 데이터가 없음 (점검 요망)</div>
              <div>- 시장 : 전날 기준 데이터 없음. 평일 10시 이전(시장이 열리기 전)이나 주말에는 누락이 나타날 수 있음.</div>
              <div>- 착유량 : 전날 기준 데이터 없음</div>
              <div>- 한전 : 오늘 날짜 기준 데이터 미수신</div>
            </div>
          </div>
        </div>
        

        <div v-if="dataloading" class="loading-container" >
          <div class="spinner"></div>
        </div>

        <div v-else class="mt-3">
          <div class="flex s-bt pa-2 align-center">
            <div class="data-title">
              <v-icon class="mr-1" color="black">mdi-truck</v-icon>
              출하
            </div>
            <div class="warning-data" @click="shipDialog = true"> 출하 데이터 점검 필요 ‣ {{ shipWarningCount }} 농가</div>
          </div>
          <div class="line"></div>

          <!--출하 크롤링-->
          <v-dialog
          v-model="shipDialog"
          width="400"
        >
          <v-card
            max-width="400"
          >
          <div class="dialog-title flex s-bt"> 
            <div>
              <v-icon color="white" class="mr-1">mdi-truck</v-icon>
              출하 크롤링 현황
            </div>
            <div @click="shipDialog = false;" style="cursor: pointer;">
              <v-icon color="white">mdi-close</v-icon>
            </div>
          </div>
          
          <div class="pa-5" >
            <div v-for="group in shipData" :key="group.key"  class="upload-detail mb-1">
              <div class="upload-detail-title">
                <span class="bold-weight">🗓️ {{ group.label }}</span>
              </div>

              <div class="upload-container" v-if="group.key == 'nodata' " >
                <div class="upload-detil-contents" v-for="(value, v) in group.farms" :key="v">
                    <span class="upload-label">{{ value.farm_no }}</span>
                    <div class="small-text"> {{ value.farm_name }} </div>
                </div>
              </div>

              <div class="shipupload-container" v-else>
                <div class="shipupload-detil-contents" v-for="(value, v) in group.farms" :key="v">
                  
                  <div class="small-text" style="width:75px;"> {{ value.farm_name }} </div>
                  <span style="font-size:0.7rem;">{{ value.farm_no }}</span>

                  <div class="small-text">{{ value.last_date }}</div>
                </div>
              </div>
            </div>
            </div>
          </v-card>
        </v-dialog>

          <div class="flex s-bt pa-2 align-center">
            <div class="data-title">
              <v-icon class="mr-1" color="black">mdi-cash-multiple</v-icon>
              시장
            </div>
            <div>{{ marketLatest }}</div>

            <div v-if="marketOmission.length > 0" class="craw-end">
              <span class="xs-text omission-sub" v-for="kind in marketOmission" :key="kind">
                {{kind}}
              </span>
              <span class="craw-chip omission" style="cursor: default;">누락</span>
            </div>

            <div v-else class="craw-end">
              <span class="craw-chip normal">정상</span>   
            </div>
          </div>
          <div class="line"></div>

          <div class="flex s-bt pa-2 align-center">
            <div class="data-title">
              <v-icon class="mr-1" color="black">mdi-cow</v-icon>
              착유량
            </div>
            <div>{{ milkLatest }}</div>
            <div v-if="milkOmission.length > 0" class="craw-end">
              <span class="xs-text omission-sub mr-1">{{ milkOmission.length }} 농가</span>
              <span class="craw-chip omission" @click="milkDialog = true">누락</span>
            </div>

            <div v-else class="craw-end">
              <span class="craw-chip normal">정상</span>   
            </div>
          </div>
          
          <!--착유량 누락시 -->
          <v-dialog
          v-model="milkDialog"
          width="400"
        >
          <v-card
            max-width="400"
          >
          <div class="dialog-title flex s-bt"> 
            <div>
              <v-icon color="white" class="mr-1">mdi-cow</v-icon>
              착유량데이터 누락 현황
            </div>
            <div @click="milkDialog = false;" style="cursor: pointer;">
              <v-icon color="white">mdi-close</v-icon>
            </div>
          </div>
            <div  class="upload-detail mb-1 pa-2">
              <div class="shipupload-container">
                <div class="shipupload-detil-contents" v-for="(value, v) in milkOmission" :key="v">
                  
                  <div class="small-text" style="width:75px;"> {{ value.farm_name }} </div>
                  <span style="font-size:0.7rem;" class="mt-1">{{ value.farm_cd }}</span>

                  <div class="small-text">{{ value.last_date }}</div>
                </div>
              </div>
            </div>
            </v-card>
          </v-dialog>

          <div class="line"></div>

          <div class="flex s-bt pa-2 align-center">
            <div class="data-title">
              <v-icon class="mr-1" color="black">mdi-weather-lightning</v-icon>
              한전
            </div>
            <div>{{ kepcoLatest }}</div>

            <div v-if="kepcoOmission.length > 0" class="craw-end">
              <span class="xs-text omission-sub mr-1">{{ kepcoOmission.length }} 농가</span>
              <span class="craw-chip omission" @click="kepcoDialog = true">누락</span>
            </div>

            <div v-else class="craw-end">
              <span class="craw-chip normal" @click="kepcoDialog = true">정상</span>   
            </div>
          </div>
          <div class="line"></div>

        <!--한전데이터 누락시 -->
        <v-dialog
          v-model="kepcoDialog"
          width="400"
        >
          <v-card
            max-width="400"
          >
          <div class="dialog-title flex s-bt"> 
            <div>
              <v-icon color="white" class="mr-1">mdi-weather-lightning</v-icon>
              한전데이터 누락 현황
            </div>
            <div @click="kepcoDialog = false;" style="cursor: pointer;">
              <v-icon color="white">mdi-close</v-icon>
            </div>
          </div>
            <div  class="upload-detail mb-1 pa-2">
              <div class="shipupload-container">
                <div class="shipupload-detil-contents" v-for="(value, v) in kepcoOmission" :key="v">
          
                  <div class="small-text" style="width:75px;"> {{ value.farm_name }} </div>
                  <span style="font-size:0.7rem;" class="mt-1">{{ value.kepco }}</span>

                  <div class="small-text" style="width:95px;">{{ value.last_date }}</div>
                </div>
              </div>
            </div>
            </v-card>
          </v-dialog>

        </div>
      </div>

      <div class="data-info info-centents">
        <div class="bold-weight">한전 동의 갱신 알림</div>

        <div v-if="kepcoloading" class="loading-container" >
          <div class="spinner"></div>
        </div>

        <div v-else class="kepco-container">
          <div class="kepcoinfo-container" v-for="(item, i) in filterKepco" :key="i" @click="kepcoDate(item)">
            <div :class="item.remaining_days < 30 ? 'kepcoWarning-contents' : 'kepco-contents'">
              <div class="bold-weight">{{ item.farm_name }} <span class="small-text" style="font-weight:400;">{{ item.kepco }}</span></div>
              <div :class="item.remaining_days < 30 ? 'kepcoWarning-chip' : 'kepco-chip'">
                {{ item.remaining_days }} 일
              </div>
            </div>
          
          </div>
        </div>
        
        <div class="kepco-notice"  v-if="!kepcoloading">
          <span class="mr-3">📢</span> 
          <span style="letter-spacing: -1px;">만료 1개월 전부터 갱신 가능합니다.</span>
        </div>
      </div>
    
      
      <div class="data-info info-centents" style="cursor:default;">
        <div class="bold-weight">업로드 데이터 관리</div>

        <div class="">
          <div class="grow-info">
          <div style="width:80%">
            <div>
              <v-icon color="#F97315" size="30" class="mr-2">mdi-upload</v-icon>
              <span class="bold-weight" style="font-size:1.1rem">한돈팜스 사육 데이터</span>
            </div>

            <div class="flex">
              <div style="width:40px;"></div>
              <div>
                <div class="small-text darkgray-color">마지막 업로드</div>
                <div>{{piglastDate}} </div>
              </div>
              <div class="mr-5 ml-5"> • </div>
              <div>
                <div class="small-text darkgray-color">사용농가</div>
                <div>{{pigGrow.length}}개 농장</div>
              </div>
            </div>
         
          </div>

          <div class="mt-2">
            <div class="upload-info" @click="uploadDiaglog = true;" style="cursor: pointer; ">업로드현황</div>
            <div @click="upload()" style="cursor: pointer;"> 
              <v-icon size="15" color="#F97315">mdi-share</v-icon> 
              <span class="small-text darkgray-color">업로드하기</span>
            </div>
          </div>
        </div>
        <v-dialog
          v-model="uploadDiaglog"
          width="400"
        >
          <v-card
            max-width="400"
          >
          <div class="dialog-title flex s-bt"> 
            <div>
              <v-icon color="white" class="mr-1">mdi-pig</v-icon>
              한돈팜스 업로드 현황
            </div>
            <div @click="uploadDiaglog = false;" style="cursor: pointer;">
              <v-icon color="white">mdi-close</v-icon>
            </div>
          </div>
          
          <div class="pa-5" >
            <div v-for="(data, d) in groupDate" :key="d" class="upload-detail mb-2">
              <div class="upload-detail-title">
                <span v-if="d === '데이터 없음'" class="bold-weight"> 데이터 없음</span> 
                <span v-else class="bold-weight">🗓️ {{ d }} 까지 업로드 완료</span>
              </div>

              <div class="upload-container">
                <div class="upload-detil-contents" v-for="value in data" :key="value.farm_no">
                  <span class="upload-label">{{ value.farm_no }}</span>
                  <div class="small-text"> {{ value.farm_name }} </div>
                </div>
              </div>
            </div>
          </div>
          </v-card>
        </v-dialog>

        <div class="kepco-info">
            <div>
              <v-icon color="#3C82F6" size="30" class="mr-2">mdi-weather-lightning</v-icon>
              <span class="bold-weight ml-text" style="font-size:1.1rem">한전 전기요금표 확인</span>
            </div>

            <div class="flex j-center">
              <div style="width:40px;"></div>

              <div class="flex align-center" @click="kepco()" style="cursor:pointer;"> 
                <v-icon size="18" color="#3C82F6" class="mr-1">mdi-share</v-icon> 
                <span class="small-text darkgray-color bold-weight">한전 전기요금표<br>
                확인하기</span>
              </div>

              <div class="flex align-center" @click="kepcoUpload()" style="cursor:pointer;"> 
                <v-icon size="18" color="#3C82F6" class="mr-1">mdi-share</v-icon> 
                <span class="small-text darkgray-color bold-weight">전기요금표<br>
                업로드하기</span>
              </div>

              <div class="flex align-center" @click="pastkepcoUpload()" style="cursor:pointer;"> 
                <v-icon size="18" color="#3C82F6" class="mr-1">mdi-share</v-icon> 
                <span class="small-text darkgray-color bold-weight">과거전력고지서<br>
                업로드하기</span>
              </div>

            </div>
          </div>
        </div>
      
      </div>
    </div>
  </div>
</template>

<script>
import { Doughnut } from 'vue-chartjs/legacy';
import { Chart as ChartJS, Title, Tooltip, Legend, ArcElement } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(ChartDataLabels, Title, Tooltip, Legend, ArcElement);

import Apis from '@/api/apis';
import dateUtil from "@/utils/custom/dateProperty.js";
// import Common from "@/utils/custom/common.js";
import '@/style/home.scss'

export default {
  name: 'HomeCard',
  components: {
    Doughnut
  },
  created() {
    Apis.getIpClient((res) => {
      // console.log(res);  
      let client = res
      Apis.pageCount({ //페이지뷰 카운터
        page_name: `${client.city}/${client.country}/${client.region}/${client.loc}/${client.org}/${client.postal}/${client.timezone}`,
        url: this.$route.path,
        ip: client.ip,
        division: "pigro",
      },() => {  // 정상처리
        // console.log("pageCount 호출",res);
      }).catch( (err) => {  // 개별 API 오류 처리 예제
        console.log("pageCount 호출 오류",err);
      });
    }).catch( (err) => {  // API 오류 처리
        console.log("getIpClient 호출 오류",err)
    }) 
   this.refresh();
  },
  computed: {
    nodeRatio(){
      return ((this.nodeStatus.connected / this.nodeStatus.total)*100).toFixed(2);
    },
    gwRatio(){
      return ((this.gwStatus.connected / this.gwStatus.total)*100).toFixed(2);
    },
    // deviceTotalRatio(){
    //   const deviceTotal = this.nodeStatus.total + this.gwStatus.total;
    //   const normalDevice = this.nodeStatus.connected + this.gwStatus.connected;
    //   return ((normalDevice / deviceTotal)* 100).toFixed(2);
    // },
    
    // deviceTotalError(){
    //   return this.nodeStatus.unconnected + this.nodeStatus.unknown  + this.gwStatus.unconnected + this.gwStatus.unknown
    // },
    fcRatol() {
      const totalSum = this.controlStatus.reduce((acc, fc) => acc + fc.total, 0);
      const normalSum = this.controlStatus.reduce((acc, fc) => acc + fc.normal, 0);

      const ratio = totalSum > 0 ? (normalSum / totalSum) * 100 : 0;
      return ratio.toFixed(2); 
    },
    fcTotalError() {
      return this.controlStatus.reduce((sum, fc) => sum + fc.abnormal, 0);
    },
    shipWarningCount() {
      const nodata = this.shipData.find(group => group.key === 'nodata');
      const old = this.shipData.find(group => group.key === 'old');
      return (nodata?.farms.length || 0) + (old?.farms.length || 0);
    }
  },
  data: () => ({ 
    farmCount:[],
    totalFarmCount:0,

    chartFarmData:{},
    chartOptions: {},
    
    AsStatus:{},

    gwStatus:{},
    nodeStatus:{},

    smsStatus:{},

    to_date:'',
    NodeConnect:[],

    deviceError:'',

    controlStatus:[],
    
    crawShip:{},
    shipData:[],

    crawMarket:{},
    crawaMilk:{},
    crawKepco:{},

    pigGrow:[],
    piglastDate:'',
    groupDate:{},

    marketOmission: [],  
    marketLatest: '',    
    milkOmission:[],
    milkLatest:'',
    kepcoOmission:[],
    kepcoLatest:'',

    dayKepco:[],
    filterKepco:[],

    //각섹션 로딩
    farmloading:false,
    asloading:false,
    gwloading:false,
    nodeloading:false,
    fcloading:false,
    sensorloading:false,
    dataloading:false,
    kepcoloading:false,
    smsloading:false,
    elecloading:false,

    uploadDiaglog:false,
    shipDialog:false,
    milkDialog:false,
    kepcoDialog:false,
    dateDialog:false,
    sensorDialog:false,

    abnormal_Sensor:[],

    menu1:false,
    extend_date:'',
    kepcoitem:{}
  }),

  methods: {
    refresh(){
      this.BizCount();
      this.monitorGateway();
      this.sensorNode();
      this.statsAS();
      this.monitorSMS();
      this.monitorControl();
      this.lastCountHeadDateOfFarms();
      this.crawData();
      this.remainKepco();

      let cdate = new Date();
      this.to_date= dateUtil.format(cdate, "yyyy-MM-dd HH:mm");
    },
    BizCount(){
      Apis.countBizGroupOfFarm({

      } ,(res) => { 
        const data = res.data;
        let total = 0;

        data.forEach(item => {
          total += item.cnt;
        });
        this.totalFarmCount = total;
        this.farmCount = data;
        
        this.chartFarmData = this.drawChart(data);

      }).catch( (err) => {  
        console.log("countBizGroupOfFarm 호출 오류",err);
      }) 
    },
    lastCountHeadDateOfFarms(){

      Apis.lastCountHeadDateOfFarms({

      } ,(res) => { 
        const rawData = res.data;
        
        //최신 날짜
        const dates = rawData
          .map(f => f.last_date)
          .filter(d => d) 
          .sort();

        const latest = dates.pop();

        //last_date 별로 묶기
        const lastDate = rawData.reduce((acc, farm) => {
        const key = farm.last_date || '데이터 없음';
          if (!acc[key]) acc[key] = [];
          acc[key].push(farm);
          return acc;
        }, {});


        this.pigGrow = rawData;
        this.piglastDate = latest || '데이터 없음';
        this.groupDate = lastDate || '데이터 없음';

 
        // console.log(this.pigGrow)
      }).catch( (err) => {  
        console.log("lastCountHeadDateOfFarms 호출 오류",err);
      }) 
    },
    crawData(){
      this.dataloading = true;

      Apis.monitorCrawlingFarms({
        "detail" : false
      } ,(res) => { 
        this.crawShip = res.data.ship;
        this.crawMarket = res.data.market;
        this.crawMilk = res.data.milk;
        this.crawKepco = res.data.kepco;

        this.errorShip();
        this.errorMarket();
        this.errorMilk();
        this.errorKepco();
        
        this.dataloading = false;
        // console.log(this.pigGrow)
      }).catch( (err) => {  
        console.log("monitorCrawlingFarms 호출 오류",err);
      }) 
    },
    //출하 크롤링 초과일수
    errorShip(){
      const today = new Date();
      const errorDay = 7;

      const result = [
        { key: 'nodata', label: '출하 데이터 없음', farms: [] },
        { key: 'old', label: '출하 지연 (7일 초과)', farms: [] },
        { key: 'recent', label: '최근 출하 수신', farms: [] }
      ];

      this.crawShip.forEach(farm => {
        if (!farm.last_date) {
          result.find(g => g.key === 'nodata').farms.push(farm);
        } else {
          const lastDate = new Date(farm.last_date);
          const diffDays = (today - lastDate) / (1000 * 60 * 60 * 24);

          if (diffDays > errorDay) {
            result.find(g => g.key === 'old').farms.push(farm);
          } else {
            result.find(g => g.key === 'recent').farms.push(farm);
          }
        }
      });

      this.shipData = result;
      // console.log(this.shipData)
  
    },
    errorMarket(){
      const today = new Date();
      const yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);
      const ymd = yesterday.toISOString().split('T')[0];

      const omission = this.crawMarket
        .filter(item => item.last_date !== ymd)
        .map(item => item.kind);

      this.marketOmission = omission;

      this.marketLatest = this.crawMarket
        .map(item => item.last_date)
        .filter(Boolean)
        .sort()
        .pop() || '데이터 없음';
    },
    errorMilk(){
      const today = new Date();
      const yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);
      const ymd = yesterday.toISOString().split('T')[0];

      const omission = this.crawMilk
        .filter(item => item.last_date !== ymd);

      this.milkOmission = omission;

      this.milkLatest = this.crawMilk
        .map(item => item.last_date)
        .filter(Boolean)
        .sort()
        .pop() || '데이터 없음';
    },
    errorKepco(){
      const today = new Date();
      const ymd = today.toISOString().split('T')[0];
      
      const omission = this.crawKepco
        .filter(item => item.last_date !== ymd);
      // console.log(this.crawData)
      this.kepcoOmission = omission;

      this.kepcoLatest = this.crawKepco
        .map(item => item.last_date)
        .filter(Boolean)
        .sort()
        .pop() || '데이터 없음';

    },
    drawChart(data){
      this.drawChartOption();
      const labels = data.map(item => item.div);
      const values = data.map(item => item.cnt);
      const colors = ['#8BBDFC', '#87DC9B', '#F4DA65', '#F3AA9B', '#F2C36C', '#D4ACFC'];

      return {
        labels,
        datasets: [
          {
            data: values,
            backgroundColor: colors
          }
        ]
      };
    },
    drawChartOption(){
      this.chartOptions = {
        responsive: true,
        maintainAspectRatio: false, 
        plugins: {
          legend: {
            position: 'right',
            labels: {
              usePointStyle: true,       
              pointStyle: 'circle',
              boxWidth: 8,    
              boxHeight: 8,   
              // padding: 25,
              font: {
                size: 15
              },    
              generateLabels: function(chart) {
                const data = chart.data;
                return data.labels.map((label, i) => {
                  const value = data.datasets[0].data[i];
                  return {
                    text: `${label} ${value}개`,
                    fillStyle: data.datasets[0].backgroundColor[i],
                    strokeStyle: data.datasets[0].backgroundColor[i],
                    index: i,
                    pointStyle: 'circle' ,
                  };
                });
              }
            }
          },
          datalabels: {
            formatter: (value, context) => {
              const data = context.chart.data.datasets[0].data;
              const total = data.reduce((a, b) => a + b, 0);
              const percentage = ((value / total) * 100).toFixed(1);
              return `${percentage}%`;
            },
            color: '#fff',
            font: {
              weight: 'bold',
              size: 12
            }
          }
        }
      };
    },
    statsAS(){
      this.asloading = true;

      Apis.statsAS({
      } ,(res) => { 
        this.AsStatus = res.data;
        this.asloading = false;
      }).catch( (err) => {  
        console.log("statsAS 호출 오류",err);
      }) 
    },
    monitorGateway(){
      if (this.msgFlag) this.$store.commit("resMessage","");
      this.gwloading = true;

      Apis.monitorGateway({
        "detail" : false,
      } ,(res) => { 
        this.gwStatus = res.data;

        this.gwloading = false;
      }).catch( (err) => {  
        console.log("monitorGateway 호출 오류",err);
      }) 
    },
    sensorNode(){
      if (this.msgFlag) this.$store.commit("resMessage","");
      this.nodeloading = true;
      Apis.monitorSensorNodes({
        "detail" : false,
      } ,(res) => { 
        this.nodeStatus = res.data;

        this.nodeloading = false;
      }).catch( (err) => {  
        console.log("monitorSensorNodes 호출 오류",err);
      }) 
    },
    monitorSMS(){
      if (this.msgFlag) this.$store.commit("resMessage","");
      this.smsloading = true;
      Apis.monitorSMS({
        "detail" : false,
      } ,(res) => { 
        this.smsStatus = res.data;

        this.smsloading = false;
      }).catch( (err) => {  
        console.log("monitorSMS 호출 오류",err);
      }) 

    },
    monitorControl(){
      if (this.msgFlag) this.$store.commit("resMessage","");
      this.fcloading = true;

      Apis.monitorControllers({
        "detail" : false,
      } ,(res) => { 
        this.controlStatus = res.data;

        // console.log(this.controlStatus)

        this.fcloading = false;
      }).catch( (err) => {  
        console.log("monitorControllers 호출 오류",err);
      }) 
    },
    remainKepco(){
      this.kepcoloading = true;
      if (this.msgFlag) this.$store.commit("resMessage","");

      Apis.remainingDaysAgreedForKepco({
        
      } ,(res) => { 
        const allKepco = res.data ;

        // 60일 이하 필터 (갱신 초과된 항목은 제외)
        const deadKepco = allKepco.filter(f => f.remaining_days !== null && f.remaining_days >= 0 && f.remaining_days <= 60).sort((a, b) => a.remaining_days - b.remaining_days);


        this.dayKepco = allKepco;
        this.filterKepco = deadKepco;
        this.kepcoloading = false;

      }).catch( (err) => {  
        console.log("remainingDaysAgreedForKepco 호출 오류",err);
      }) 
    },
    kepcoDate(item){
      this.dateDialog = true;
      this.kepcoitem = item;
    },
    fcRatio(val){
      return ((val.normal / val.total) * 100).toFixed(2);
    },
    abnormalSensor(){
      this.sensorDialog = true;
      this.sensorloading = true;
      Apis.monitorSensorNodes({
        "detail" : true,
        "select" : "abnormal"
      } ,(res) => { 
        this.abnormal_Sensor = res.data;
        
        this.sensorloading = false;

      }).catch( (err) => {  
        console.log("monitorSensorNodes 호출 오류",err);
      }) 
      
    },
    sensorText(value){
      return value.split('수신')[0];
    },
    roterBarometer(info){
      // console.log(info)
      this.$router.push({
        name: "Barometer",
        params: { 
          company: {code: info.company_cd, name: info.company},
          farm: {code: info.farm_cd, name: info.farm},
          building: {code: info.building_cd, name: info.building},
          room: {code: info.room_cd, name: info.room + " " + info.farm},
          }
      });
    },
    
    upload() {
      document.domain.includes('pigro') ||  document.domain.includes('admin')// 실서비스 
      ?
      window.open('https://api.onespring.co.kr/monthly_breeding', '_blank')
      // "http://pigro.onespring.co.kr:4011/"
      :
      window.open('https://dev-api.onespring.co.kr/monthly_breeding', '_blank');

      // window.open('https://api.onespring.co.kr/monthly_breeding', '_blank');
    },
    kepco(){
      window.open('https://online.kepco.co.kr/PRM004D00', '_blank');
    },
    kepcoUpload(){
      document.domain.includes('pigro') ||  document.domain.includes('admin')// 실서비스 
      ?
      window.open('https://api.onespring.co.kr/elec_charge', '_blank')
      // "http://pigro.onespring.co.kr:4011/"
      :
      window.open('https://dev-api.onespring.co.kr/elec_charge', '_blank');
      
      // window.open('https://api.onespring.co.kr/elec_charge', '_blank');
    },
    pastkepcoUpload(){
      document.domain.includes('pigro') ||  document.domain.includes('admin')// 실서비스 
      ?
      window.open('https://api.onespring.co.kr/elec_bill', '_blank')
      // "http://pigro.onespring.co.kr:4011/"
      :
      window.open('https://dev-api.onespring.co.kr/elec_bill', '_blank');

      // window.open('https://api.onespring.co.kr/elec_bill', '_blank');
    }
  }
}

</script>

<style lang="scss">
// @import "../style/home.scss";

.loading-container{
  transform: translate(0,100%); 
}
.connect-loading{
  height:3vh;
  transform: translate(-45%, 5px); 
}
.thin-spinner {
  width: 25px;
  height: 25px;
  border: 2px solid rgba(0, 0, 0, 0.1);
  border-top: 2px solid #4A5568;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
  margin: auto;
}
.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-top: 4px solid #4A5568;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: auto;
}
.dialog-title{
    padding:15px;
    background-color: #4A5568;
    color:white;
    font-weight:600;
  }
  .upload-detail{
    border-radius: 10px;
    border: 1px solid #E5E7EB;
  }
  .upload-detail-title{
    padding:10px;
    background-color: #EFF6FF;
  }
  .upload-container-outer{
    display: flex;
    justify-content: center;
  }
  .upload-container{
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    gap: 5px;
    padding:5px;
    margin-left:15px;
  }
  .shipupload-container{
    padding:5px;
  }
  .shipupload-detil-contents{
    width:100%;
    padding:3px 5px;
    border:1px solid #E5E7EB;
    border-radius: 5px;
    margin-top:3px;
    display: flex;
    justify-content: space-between;
  }
  .upload-detil-contents{
    text-align: center;
    width: 100px;
    border-radius: 10px;
    border:1px solid #E5E7EB;
    line-height: 18px;
    padding:2px;
  }
  .upload-label{
    padding:0 7px;
    border-radius: 20px;
    background-color: #e1e1e1;
    font-size:0.6rem;
  }
  .data-title{
    width:80px;
  }
  .warning-data , .craw-chip{
    background-color: #F3AA9B;
    padding:3px 10px;
    border-radius: 10px;
    color:white;
    font-weight:600;
    letter-spacing: -1px;
    cursor: pointer;
  }
  .normal{
    background-color: #EFFDF4;
    color:#238346;
    cursor: default;
  }
  .omission{
    background-color: #F3AA9B;
    color:white;
  }
  .omission-sub{
    color: #F63C3C;
    font-weight:650;
  }
  .craw-end{
    width:100px;
    text-align: end;
  }
  .craw-info {
    cursor: pointer;
  }
  .abnormal-sensor-container{
    background: #EFFDF4;
    border: 1px solid #BBF7D0;
    padding:5px 10px;
    border-radius: 10px;
  }
  .normal-sensor{
    display: flex;
    flex-wrap: wrap;
    gap: 0 12px; 
  }
  .normal-sensor > div {
    width: calc(33.33% - 8px); 
    box-sizing: border-box;
  }
  .abnormal-sensor-list{
    background: #FFF7ED;
    border: 1px solid #FED7AA;
  }
  .abnormal-sensor{
    display: flex;
    flex-wrap: wrap;
  }
  .sensor-chip{
    background-color: #ff852e;
    padding:2px 10px;
    font-size: 0.9rem;
    border-radius: 15px;
    margin: 0 5px;
    color:white;
  }
  .abnormal-sensor > div {
    box-sizing: border-box;
    font-weight:550;
  }
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>